export default __webpack_public_path__ + "static/media/Category.1c4016bd.svg";